'use strict';

import { appendQueryParams } from '../utils';

export default (API) => ({
    forms: {
        getAvailableForms: (establishmentId, formGroup = null) => {
            let url = `/v3/establishments/${establishmentId}/available-forms`;
            if (formGroup) url += `?formGroup=${formGroup}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getFormDetail: (establishmentId, formId) => {
            let url = `/v3/establishments/${establishmentId}/available-forms/${formId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getFormById: (establishmentId, appointmentId, formId) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms/${formId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getTodayForms: (params) => {
            const { establishmentId, limit, currentPage, sortBy, descending, hideCompletedForms } = params;
            let url = `/v3/establishments/${establishmentId}/forms/today?page=${currentPage}&limit=${limit}&sortBy=${sortBy}`;
            url = descending ? `${url}&descending=${descending}` : url;
            url = hideCompletedForms ? `${url}&hideCompletedForms=${hideCompletedForms}` : url;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getFormsBySearch(establishmentId, params) {
            let url = `/v3/establishments/${establishmentId}/forms`;
            url = appendQueryParams(url, params);
            const request = API.http.get(url);
            return API.handleError(request);
        },

        updateForm: (establishmentId, appointmentId, formId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms/${formId}`;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        createFormFromPublic: (establishmentId, appointmentId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/dataCollection`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        updateFormStatus: (establishmentId, appointmentId, formId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms/${formId}/status`;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        transmitForm: (establishmentId, appointmentId, formId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms/${formId}/transmit`;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        exportForm: (establishmentId, appointmentId, formId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms/export`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        exportTemplateForm: (formId, configVersionNumber, params) => {
            let url = `/v3/forms/${formId}/config-version/${configVersionNumber}/export`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        batchExportForm: (establishmentId, params) => {
            let url = `/v3/establishments/${establishmentId}/forms/batch-export`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        createAppointmentForm: (establishmentId, appointmentId, params) => {
            let url = `/v3/establishments/${establishmentId}/appointments/${appointmentId}/forms`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        getFormConfig: (formId, configVersionId) => {
            let url = `/v3/forms/${formId}/config-version/${configVersionId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },
    },
});
